import { dueDate, daysBetween } from './dates.js';
export const KINDS = {
    onboarding: {
        kind: 'onboarding', label: 'Onboarding',
        anchors: [{ key: 'offer', label: 'Offer accepted' }, { key: 'start', label: 'Start date' }],
        phases: ['Before day 1', 'Day 1', 'First two weeks', 'Probation'],
    },
    offboarding: {
        kind: 'offboarding', label: 'Offboarding',
        anchors: [{ key: 'notice', label: 'Notice received' }, { key: 'last', label: 'Last day' }],
        phases: ['On notice', 'Before last day', 'Last day', 'After leaving'],
    },
};
export function appliesTo(applies, engagement) {
    switch (applies) {
        case 'all': return true;
        case 'employee': return engagement !== 'contractor';
        case 'contractor': return engagement === 'contractor';
        case 'casual': return engagement === 'casual';
    }
}
/** The All staff list plus every list assigned to the person's role. */
export function listsForPerson(person, lists) {
    return lists.filter((l) => l.isCore || (person.roleKey !== null && l.roles.includes(person.roleKey)));
}
/**
 * Due date for one task. The last-day account lock is never moved for weekends or holidays:
 * moving it earlier would lock someone out while still working; later would break KPI K18.
 */
export function taskDueDate(item, anchorIso, rule, holidays = new Set()) {
    if (!anchorIso)
        return null;
    return item.autoAction === 'lock_account' ? dueDate(anchorIso, item.offsetDays, 'none') : dueDate(anchorIso, item.offsetDays, rule, holidays);
}
/** Freeze the items that apply to this person (the snapshot a run keeps) and compute due dates. */
export function planTasks(person, lists, kind, anchors, rule, holidays = new Set()) {
    const items = lists.flatMap((l) => l.items.map((i) => ({ ...i, listName: l.name })));
    const anchorIndex = (a) => kind.anchors.findIndex((x) => x.key === a);
    return items
        .filter((i) => i.title.trim() !== '' && appliesTo(i.applies, person.engagementType))
        .map((i) => ({ ...i, dueDate: taskDueDate(i, anchors[i.anchor], rule, holidays) }))
        .sort((x, y) => {
        const p = kind.phases.indexOf(x.phase) - kind.phases.indexOf(y.phase);
        if (p !== 0)
            return p;
        if (x.dueDate && y.dueDate && x.dueDate !== y.dueDate)
            return x.dueDate < y.dueDate ? -1 : 1;
        return anchorIndex(x.anchor) - anchorIndex(y.anchor) || x.offsetDays - y.offsetDays;
    });
}
export function taskState(t, today) {
    if (t.doneAt)
        return { state: 'done', days: null };
    if (t.failed)
        return { state: 'failed', days: null };
    if (!t.dueDate)
        return { state: 'no_date', days: null };
    const d = daysBetween(today, t.dueDate);
    if (d < 0)
        return { state: 'overdue', days: d };
    if (d === 0)
        return { state: 'today', days: 0 };
    if (d <= 7)
        return { state: 'soon', days: d };
    return { state: 'later', days: d };
}
/** Owner of a task who should get the reminder email n days before it is due. */
export function reminderDue(t, today, remindDays) {
    if (t.doneAt || !t.dueDate)
        return false;
    return daysBetween(today, t.dueDate) === remindDays;
}
/** Critical tasks overdue by at least `escalateDays` go to the Director. */
export function escalationDue(t, today, escalateDays) {
    if (t.doneAt || !t.dueDate || !t.critical)
        return false;
    return daysBetween(t.dueDate, today) >= escalateDays;
}
//# sourceMappingURL=checklists.js.map